import React, { useEffect } from "react";
import "./header.css";

const ai = "/assets/img/hero/hero1.svg";

export default function Header() {
  /*  useEffect(() => {
    init();
  }, []); */

  return (
    <div>
      <section className="scrobits__header section__padding" id="home">
        <div className="scrobits__header-content">
          <h1>
            <span>
              Elegant <span className="gradient__text"> Web, Mobile &#38;</span>{" "}
            </span>
            <span className="gradient__text"> Digital Experiences </span>{" "}
            <span>For Your Business</span>
          </h1>
          <h2>
            Making human-digital interaction more immersive and responsive.
          </h2>

          {/* field to get input such as subscription mail */}
          <div className="scrobits__header-content__input">
            {/* <input type="email" placeholder="Your Email Address" /> */}
            <button
              className="scrobits__header-content__input-button"
              type="button"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = "/get-started";
              }}
            >
              Get Started
            </button>
          </div>
        </div>

        <div className="scrobits__header-image">
          {/* <ThreeDemo /> */}
          <img src={ai} alt="Internet in hand" />
        </div>
      </section>
    </div>
  );
}
